import { memo, Suspense } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import Loader from "../components/loader";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "../components/error-boundary-fallback/ErrorBoundaryFallback";
import Layout from "../components/layout/Layout";
import { LAYOUTS } from "../constant";
import DashboardLayout from "components/layout/DashboardLayout";
import BrowserService from "service/browser.service";

const PrivateRouter = ({
    title,
    layout,
    breadcrumb,
    allowedRoles,
    auth
}) => {
    const location = useLocation();

    if (!auth) {
        auth = BrowserService.getCookie('token') ?? false;
    }

    const { MAIN, DASHBOARD_LAYOUT } = LAYOUTS;

    function getLayout() {
        switch (layout) {
            case MAIN:
                return (
                    <Layout breadcrumb={breadcrumb}>
                        <Outlet />
                    </Layout>
                )

            case DASHBOARD_LAYOUT:
                return (
                    <DashboardLayout breadcrumb={breadcrumb}>
                        <Outlet />
                    </DashboardLayout>
                )

            default:
                return <Outlet />
        }
    }

    switch (auth) {
        case false:
            return (
                <Navigate to={'/login'} state={{ from: location }} replace />
            )
        default:
            return (
                <Wrapper
                    title={title}
                    allowedRoles={allowedRoles}
                    getLayout={getLayout}
                />
            )
    }
};

const Wrapper = ({ title, allowedRoles, getLayout }) => {
    const role = JSON.parse(localStorage.getItem("authDetails"))?.userType;
    const isAllowed = allowedRoles.includes(role);

    switch (true) {
        case isAllowed:
            return (
                <>
                    <title>{title}</title>
                    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
                        <Suspense fallback={<Loader />}>
                            {getLayout()}
                        </Suspense>
                    </ErrorBoundary>
                </>
            )

        default:
            return (
                <Navigate to={'/access-denied'} replace />
            )
    }
}

export default memo(PrivateRouter);
